module.exports = __webpack_public_path__ + "01_medium_brown.d02b31c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_medium_brown.png
// module id = PNy9
// module chunks = 0